import { type ComponentType } from 'react'

import { DIALOG_IDS, type TDialogId } from '@core/modal'
import {
    AsyncAudacityDownloadDialogContainer,
    AsyncLinkAudacityDialogContainer,
} from '@features/audacity'
import { AsyncHqDialogContainer } from '@features/audio-player'
import { AsyncAuthModalContainer } from '@features/auth'
import { AsyncFirstLikeDialogContainer } from '@features/audio-like'
import { AsyncDownloadDialogContainer } from '@features/audio-download'
import {
    AsyncCheckoutDialogContainer,
    AsyncPurchaseSuccessDialogContainer,
} from '@features/checkout'
import { AsyncAddToCollectionsDialogContainer } from '@features/collection'
import { AsyncGiftDialogContainer } from '@features/donate'
import { AsyncAnniversaryDialogContainer } from '@features/anniversary-promo'
import { AsyncConverterPromoDialogContainer } from '@features/feature-promos'
import {
    AsyncHqStoragePaywallDialogContainer,
    AsyncPaywallDialogContainer,
} from '@features/paywall'
import { AsyncEmbedDialogContainer, AsyncShareDialogContainer } from '@features/share'

type TTriggerOwnedDialogId =
    | typeof DIALOG_IDS.createCollection
    | typeof DIALOG_IDS.deleteCollection
    | typeof DIALOG_IDS.editCollectionAudio
    | typeof DIALOG_IDS.followers
    | typeof DIALOG_IDS.following
    | typeof DIALOG_IDS.reportMissing

type TGlobalDialogContainers = Omit<Record<TDialogId, ComponentType>, TTriggerOwnedDialogId>

type TGlobalDialogId = keyof TGlobalDialogContainers

export const DIALOG_CONTAINERS: TGlobalDialogContainers = {
    [DIALOG_IDS.giftSub]: AsyncGiftDialogContainer,
    [DIALOG_IDS.addToCollection]: AsyncAddToCollectionsDialogContainer,
    [DIALOG_IDS.share]: AsyncShareDialogContainer,
    [DIALOG_IDS.embed]: AsyncEmbedDialogContainer,
    [DIALOG_IDS.hqInfo]: AsyncHqDialogContainer,
    [DIALOG_IDS.download]: AsyncDownloadDialogContainer,
    [DIALOG_IDS.firstLike]: AsyncFirstLikeDialogContainer,
    [DIALOG_IDS.auth]: AsyncAuthModalContainer,
    [DIALOG_IDS.linkAudacity]: AsyncLinkAudacityDialogContainer,
    [DIALOG_IDS.audacityDownload]: AsyncAudacityDownloadDialogContainer,
    [DIALOG_IDS.paywall]: AsyncPaywallDialogContainer,
    [DIALOG_IDS.checkout]: AsyncCheckoutDialogContainer,
    [DIALOG_IDS.purchaseSuccess]: AsyncPurchaseSuccessDialogContainer,
    [DIALOG_IDS.converterPromo]: AsyncConverterPromoDialogContainer,
    [DIALOG_IDS.anniversaryPromo]: AsyncAnniversaryDialogContainer,
    [DIALOG_IDS.hqStoragePaywall]: AsyncHqStoragePaywallDialogContainer,
}

export const isGlobalDialog = (id: TDialogId | null): id is TGlobalDialogId =>
    id !== null && id in DIALOG_CONTAINERS
